// Copyright (c) 2019 Verimatrix, Inc.  All Rights Reserved.

import React from 'react'
import {Switch, Route, Link} from 'react-router-dom'
import history from '../history'

import UnifiedPortal from './UnifiedPortal/'

export function renderRoutes () {
  return (
    <Switch>
      <Route path='/' component={UnifiedPortal}/>
      <Route path='*' render={() => <div>{history.push('/')}</div>} />
    </Switch>
  )
}

export function renderMenuLinks () {
  return (
    <React.Fragment>
      <li><Link className='btn' to='/'><i className='fal fa-fw fa-home'/>Home</Link></li>
    </React.Fragment>
  )
}
